import { Button, Modal, Select } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import {
  loadSingleTicket,
  updateTicket,
} from "../../../../redux/rtk/features/crm/ticket/ticketSlice";
import { loadAllTicketStatus } from "../../../../redux/rtk/features/crm/ticketStatus/ticketStatusSlice";
import UserPrivateComponent from "../../../PrivateRoutes/UserPrivateComponent";
import { IoSyncOutline, IoCheckmarkCircleOutline } from "react-icons/io5";
import "./TicketStatusUpdate.css";

const TicketStatusUpdate = () => {
  const [open, setOpen] = useState(false);
  const [ticketStatusId, setTicketStatusId] = useState("");
  const { ticket, loading } = useSelector((state) => state.ticket);
  const { list, loading: ticketStatusLoading } = useSelector(
    (state) => state.ticketStatus
  );
  const { id } = useParams("id");

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(loadAllTicketStatus());
  }, [dispatch]);

  const showModal = () => {
    setOpen(true);
  };
  const handleOk = async () => {
    const resp = await dispatch(
      updateTicket({ id: id, values: { ticketStatusId: ticketStatusId } })
    );
    if (resp.payload.message === "success") {
      dispatch(loadSingleTicket(id));
      setOpen(false);
      setTicketStatusId("");
    }
  };
  const handleCancel = () => {
    setOpen(false);
    setTicketStatusId("");
  };
  return (
    <>
      <UserPrivateComponent permission={"update-ticket"}>
        <Button
          icon={<IoSyncOutline />}
          type='primary'
          onClick={showModal}
          className='ticket-details-update-status flex items-center gap-1'
        >
          Update Status
        </Button>
      </UserPrivateComponent>

      <Modal
        open={open}
        onCancel={handleCancel}
        footer={null}
        width={440}
        className='status-update-modal'
        destroyOnClose
      >
        <div className='status-update-header'>
          <span className='status-update-icon'>
            <IoSyncOutline />
          </span>
          <div>
            <h3>Update Post Status</h3>
            <p>
              Currently: <strong>{ticket?.ticketStatus?.ticketStatusName}</strong>
            </p>
          </div>
        </div>

        <div className='status-update-body'>
          <label className='status-update-label'>New status</label>
          <Select
            size='large'
            className='status-update-select'
            placeholder='Select a new status'
            defaultValue={ticket?.ticketStatus?.ticketStatusName}
            loading={ticketStatusLoading}
            onChange={(value) => {
              setTicketStatusId(value);
            }}
            style={{ width: "100%" }}
          >
            {list.map((item) => (
              <Select.Option key={item.id} value={item.id}>
                {item.ticketStatusName}
              </Select.Option>
            ))}
          </Select>

          <div className='status-update-actions'>
            <Button onClick={handleCancel} className='status-update-cancel'>
              Cancel
            </Button>
            <Button
              type='primary'
              icon={<IoCheckmarkCircleOutline />}
              onClick={handleOk}
              loading={loading}
              disabled={!ticketStatusId}
              className='status-update-confirm'
            >
              Update
            </Button>
          </div>
        </div>
      </Modal>
    </>
  );
};
export default TicketStatusUpdate;
